<template>
  <div class="room-navigator-wrap">
    <i class="back" @click="$router.go(-1)"></i>
    <Tool />
    <i class="setting" @click="$emit('setting')"></i>
  </div>
</template>

<script>
import Tool from '@/components/Tool';

export default {
  components: { Tool },
};
</script>

<style lang="less" scoped>
.room-navigator-wrap {
    height: 56px;
    /* background-color: pink; */
    padding: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .back {
      .iconMixin({
        background-image: url('~@/assets/images/chat/back.png');
      })
    }
    .setting {
      margin-left: 13px;
      .iconMixin({
        background-image: url('~@/assets/images/chat/setting.png');
      })
    }

}
</style>
